import { api_GET } from "./_api.js";

const funcionalidades_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Funcionalidades`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    ValidadarAcessoFuncionalidade:  (funcionalidade) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Funcionalidades/ValidadarAcessoFuncionalidade/${funcionalidade}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default funcionalidades_api;